import { composeHoc } from '../../../utils';
import { BaseCell } from './base-cell';
import { ICellRenderProps } from './interface';

import { withPositiveNegative } from './with-positive-negative';
import { withTrophy } from './with-trophy';

export const CellRender: React.FC<ICellRenderProps> = composeHoc(
  withPositiveNegative,
  withTrophy
)(BaseCell);
